import { useStore } from "ra-core";
import { useCallback, useMemo } from "react";
import {
  CONFIGURATION_STORE_KEY,
  useConfigurationContext,
} from "@/components/atomic-crm/root/ConfigurationContext";
import {
  legacyProbabilities,
  normalizeStages,
  stageColor,
  type StageDef,
} from "../domain/deals/stageModel";

/** The configured stages (config.dealStages, normalised; the defaults until the configuration loads). */
export const useDealStages = (): StageDef[] => {
  const { dealStages } = useConfigurationContext();
  const [config] = useStore<unknown>(CONFIGURATION_STORE_KEY, {});
  // the legacy overlay only before dealStages is stored (the stage's own probability wins, as in SQL)
  const legacy = legacyProbabilities(config);
  return useMemo(
    () => normalizeStages(dealStages, legacy),
    [dealStages, legacy],
  );
};

/** The colour of a stage value (an unknown / deleted value: neutral grey). */
export const useStageColor = () => {
  const stages = useDealStages();
  return useCallback((value: string) => stageColor(stages, value), [stages]);
};
